import { SMALL_ELITE_ORG } from "./orgIds.js";

export const SMALL_ELITE_LIMIT = 10;

export function ownedCardCount(run: {
  deck: readonly unknown[];
  discard: readonly unknown[];
  hand: readonly unknown[];
  inPlay: readonly unknown[];
  aside: readonly unknown[];
  caseExcluded?: readonly unknown[];
}): number {
  return (
    run.deck.length
    + run.discard.length
    + run.hand.length
    + run.inPlay.length
    + run.aside.length
    + (run.caseExcluded?.length ?? 0)
  );
}

export function ownedCardCountById(
  run: {
    deck: readonly { cardId: string }[];
    discard: readonly { cardId: string }[];
    hand: readonly { cardId: string }[];
    inPlay: readonly { cardId: string }[];
    aside: readonly { cardId: string }[];
    caseExcluded?: readonly { cardId: string }[];
  },
  cardId: string,
): number {
  return [run.deck, run.discard, run.hand, run.inPlay, run.aside, run.caseExcluded ?? []]
    .flat()
    .filter((card) => card.cardId === cardId)
    .length;
}

export function hasSmallEliteBonus(
  organizations: readonly string[],
  count: number,
): boolean {
  return organizations.includes(SMALL_ELITE_ORG) && count <= SMALL_ELITE_LIMIT;
}
